import { render, staticRenderFns } from "./dataAgreementView.vue?vue&type=template&id=c8b6aaa2&scoped=true&"
import script from "./dataAgreementView.vue?vue&type=script&lang=js&"
export * from "./dataAgreementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b6aaa2",
  null
  
)

export default component.exports